import { Box, Card, CardContent, Grid2 as Grid, Skeleton, Stack } from '@mui/material';

export function DashboardSkeleton() {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 8 }}>
        <Card>
          <Stack direction="row" spacing={3} sx={{ p: 2.5 }}>
            {[0, 1].map((i) => (
              <Box key={i} sx={{ flex: 1 }}>
                <Skeleton width="45%" />
                <Skeleton width="30%" height={44} />
              </Box>
            ))}
          </Stack>
          <Skeleton variant="rounded" height={260} sx={{ mx: 2.5, mb: 2.5 }} />
        </Card>
      </Grid>
      <Grid size={{ xs: 12, lg: 4 }}>
        <Stack spacing={2}>
          {[0, 1].map((i) => (
            <Card key={i}><CardContent><Skeleton width="55%" /><Skeleton width="25%" height={48} /><Skeleton width="70%" /></CardContent></Card>
          ))}
        </Stack>
      </Grid>
      {[0, 1].map((i) => (
        <Grid key={i} size={{ xs: 12, md: 6 }}>
          <Card><CardContent><Skeleton width="40%" sx={{ mb: 2 }} />{[0, 1, 2, 3].map((j) => <Skeleton key={j} variant="rounded" height={10} sx={{ my: 2.5 }} />)}</CardContent></Card>
        </Grid>
      ))}
    </Grid>
  );
}

export function FormPageSkeleton() {
  return (
    <Card sx={{ maxWidth: 960, mx: 'auto' }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Stack spacing={2}>
          <Skeleton width={140} />
          <Skeleton height={56} />
          <Skeleton height={56} />
          <Skeleton height={56} />
          <Skeleton height={56} />
          <Skeleton height={40} width={160} sx={{ alignSelf: 'flex-end' }} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export function DetailSkeleton() {
  return (
    <Stack spacing={2}>
      <Card sx={{ bgcolor: (theme) => theme.palette.m3.surfaceContainerLow }}>
        <CardContent>
          <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={2}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Skeleton variant="circular" width={40} height={40} />
              <Box>
                <Stack direction="row" spacing={1}>
                  <Skeleton width={180} height={32} />
                  <Skeleton width={60} height={28} />
                </Stack>
                <Skeleton width={260} />
              </Box>
            </Stack>
            <Skeleton variant="rounded" width={140} height={40} />
          </Stack>
        </CardContent>
      </Card>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Card><CardContent><Stack spacing={1.5}>{[0, 1, 2, 3, 4].map((i) => <Skeleton key={i} height={28} />)}</Stack></CardContent></Card>
        </Grid>
        <Grid size={{ xs: 12, md: 5 }}>
          <Card><CardContent><Stack spacing={1.5}>{[0, 1, 2].map((i) => <Skeleton key={i} height={28} />)}</Stack></CardContent></Card>
        </Grid>
      </Grid>
    </Stack>
  );
}
